/** The customer sidebar round (2026-11-01, brief `docs/briefs/customer-sidebar-round.md` rules 1 and 2, decisions "Country and language"):
 *  who may set a customer's country or language, and the language code the AI's reading is stored as. Pure. */

/** who set a value, in the order of trust: a person, an outside program's explicit call, a connected site or the company's own system,
 *  the AI's reading. The database checks the same five words (`customers.country_from`, `customers.language_from`, migration 0124). */
export const PROFILE_ORIGINS = ["person", "api", "site", "endpoint", "ai"] as const;
export type ProfileOrigin = (typeof PROFILE_ORIGINS)[number];

const RANK: Record<ProfileOrigin, number> = { person: 4, api: 3, site: 2, endpoint: 2, ai: 1 };

/** whether an incoming write may set the value: an empty value may always be filled; the same or a higher rank replaces; a lower never
 *  does; a value with no origin (written before this round) counts as a person's */
export function mayFillProfile(stored: { value: string | null | undefined; from: ProfileOrigin | null | undefined }, incoming: ProfileOrigin): boolean {
  if (stored.value === null || stored.value === undefined || stored.value === "") return true;
  return RANK[incoming] >= RANK[stored.from ?? "person"];
}

/** ISO 639-1, the two-letter language codes */
const ISO_639_1 = new Set(
  ("aa ab ae af ak am an ar as av ay az ba be bg bh bi bm bn bo br bs ca ce ch co cr cs cu cv cy da de dv dz ee el en eo es et eu fa ff fi fj fo fr fy "
    + "ga gd gl gn gu gv ha he hi ho hr ht hu hy hz ia id ie ig ii ik io is it iu ja jv ka kg ki kj kk kl km kn ko kr ks ku kv kw ky la lb lg li ln lo lt "
    + "lu lv mg mh mi mk ml mn mr ms mt my na nb nd ne ng nl nn no nr nv ny oc oj om or os pa pi pl ps pt qu rm rn ro ru rw sa sc sd se sg si sk sl sm sn "
    + "so sq sr ss st su sv sw ta te tg th ti tk tl tn to tr ts tt tw ty ug uk ur uz ve vi vo wa wo xh yi yo za zh zu").split(" "),
);

/** the lower-case two-letter code of a known language ("DE" → "de", "pt-BR" → "pt"); a name, an unknown code or nothing gives null */
export function languageCodeOf(raw: string | null | undefined): string | null {
  const code = (raw ?? "").trim().toLowerCase().split(/[-_]/, 1)[0] ?? "";
  return ISO_639_1.has(code) ? code : null;
}
